import { cn } from '@/lib/utils';

interface VideoDisplayTitleProps {
  title?: string;
  className?: string;
}

export default function VideoDisplayTitle({ title, className }: VideoDisplayTitleProps) {
  return (
    <span className={cn('pointer-events-none absolute z-10 left-0 bottom-0 bg-slate-700/50 p-2 text-sm text-white rounded-xl', className)}>
      {title}
    </span>
  );
}
